import { addCart } from '@/api/cart';
import { getPrice } from '@/api/price';
import { getSkuInfo } from '@/lib/gtmPoint';
import $ from 'jquery';
import manager from '../manager';
import {loginJump,isLogin} from '@/utils/login'

manager.add('cart', {
	created(sku) {
		$(this.dom).bind("click", async function () {
			if(!isLogin()){
				loginJump()
				return
			}
			try {
				await addCart(sku)
				if (window.dataLayer) {
					let price = await getPrice([sku]);
					let skuInfo = await getSkuInfo([sku]);
					window.dataLayer.push({
						event: 'addToCart',
						ecommerce: {
							add: {
								products: [{
									id: sku,
									price: price[sku].discountPrice,
									...skuInfo[sku],
									quantity: 1
								}]
							}
						}
					});
				}
			} catch (e) {
				//
			}
		})
	},
	destroyed() {
		$(this.dom).unbind("click")
	}
})
